function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}


function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  var domain = window.host
  if (window.location.href.indexOf('nachthimmel.de') > -1) {
    domain = "nachthimmel.de"
  }
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString()+";domain="+domain;
}